// extracted by mini-css-extract-plugin
export default {"exposed-secret":"JGEpbCCyrODGK2TjNmZ6","secondary-text":"Nhq8KbdM_Hk3RVVBIGCy"};